import { Menu, MenuItem } from '@material-ui/core';
import api, { Agencia, Nucleo, TipoPautaResponse } from 'api/Assessor/evento';
import { AxiosError } from 'axios';
import { CircleTimes, ThreeDots } from 'components/Icons';
import LayoutContext from 'components/Layout/LayoutContext';
import { IGenericModalProps } from 'components/Modal/__LEGACY__/GenericModal/GenericModal';
import { AnexoEnum, AnexoPautaType } from 'helpers/enums/anexoPauta';
import { AssembleiaTipoPauta } from 'helpers/enums/AssembleiaPautaStatus';
import { groupByKey } from 'helpers/utils/ArrayUtils';
import ErrorHandler from 'helpers/utils/ErrorHandler';
import { clsx } from 'helpers/utils/HTMLUtils';
import { getUniqueKey } from 'helpers/utils/KeyUtils';
import { languageValues } from 'helpers/utils/languageUtils';
import {
  AddCircleIcon,
  AddIcon,
  Button,
  ButtonFileUpload,
  ButtonThemes,
  Checkbox,
  CheckboxThemes,
  CheckCircleIcon,
  ChevronArrowDownIcon,
  Col,
  Collapse,
  ControlLabel,
  ControlLabelPosition,
  DropdownItem,
  DropdownMenu,
  FilePlusIcon,
  FileTypes,
  IconButton,
  Input,
  InputArea,
  Modal,
  ModalSizes,
  PlayIcon,
  Row,
  ScreenSize,
  Select,
  ThreeDotsLoader,
  ToastTypes,
  TrashIcon,
  useDropOpened,
} from 'plataforma-fundacao-componentes';
import React, {
  Fragment,
  MouseEvent,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useDispatch } from 'react-redux';
import {
  deleteAnexoPauta,
  deleteAnexoPautaRegister,
  getAnexosPauta,
  getAttachmentRegister,
  postAnexoPauta,
  postAnexoPautaRegister,
  putAnexoPauta,
  putAnexoPautaRegister,
} from 'services/anexoPauta';
import {
  assembleiasAssessorCadastrarPauta,
  loadDefaultStaves,
} from 'store/modules/AssembleiasAssessorActions';
import {
  ICadastrarPautaRequest,
  IItensCadastrarPautaRequest,
} from 'store/modules/AssembleiasAssessorReducer';
import { assessorActionCarregarPautas } from 'store/modules/assessor/actions';
import {
  CadastroPautaType,
  CadastroPautaValidator,
} from './CadastroPautaValidator';
import AnexoPautaItem from './components/AnexoPautaItem/AnexoPautaItem';
import PreAnexoPautaItem from './components/PreAnexoPautaItem/PreAnexoPautaItem';
import { useStyles } from './styles';

import Search from 'components/__ASSESSOR__/Search/Search';
import { getOptionsFromParams } from 'helpers/utils/dropdownUtils';
import './styles.scss';

const rootClassName = 'componente-cadastro-pauta-modal';

const MAX_INPUT_TITLE_LENGHT = 200;

export enum JobTitleTypes {
  Presidente = 'PRESIDENTE',
  VicePresidente = 'VICE_PRESIDENTE',
  ConselheiroEfetivo = 'CONSELHEIRO_EFETIVO',
  ConselheiroSuplente = 'CONSELHEIRO_SUPLENTE',
}

interface ICadastroPautaModalProps extends IGenericModalProps {
  modalKey: string;
  idEvento: any;
  status: any;
  idPauta?: any;
  anexos?: any;
  titulo?: string;
  cooperativa?: string;
  descricao?: string;
  itens?: IItensCadastrarPautaRequest[];
  tipoPauta?: AssembleiaTipoPauta;
  numeroNucleo?: string;
  codigoAgencia?: string;
  flgSecreta?: boolean;
  flgRestrita?: boolean;
  currentPage?: any;
  liberadaPresencial?: boolean;
  preventEscExit?: boolean;
  preventMaskExit?: boolean;
  mobileOn?: ScreenSize;
  onClose?: (evt: any) => void;
  onSend?: any;
  registering?: boolean;
}

interface OptionsProps {
  label: string;
  value: number;
}

interface MembersProps {
  id: number;
  cpfCnpj: string;
  name: string;
  cooperative: string;
  branch: string;
  nucleus: string;
}

interface MembersProps {
  idAssociado: number;
  name: string;
  roleName?: JobTitleTypes;
}

export const sortAnexos = (a: AnexoPautaType, b: AnexoPautaType) => {
  if (a.tipoAnexo !== b.tipoAnexo) {
    if (a.tipoAnexo === AnexoEnum.DOCUMENTO) {
      return -1;
    } else {
      return 1;
    }
  } else if (a.oidAnexoPauta) {
    if (b.oidAnexoPauta) {
      return a.oidAnexoPauta - b.oidAnexoPauta;
    } else {
      return -1;
    }
  } else if (b.oidAnexoPauta) {
    return 1;
  } else if (a.idTemporarioFront && b.idTemporarioFront) {
    return a.idTemporarioFront - b.idTemporarioFront;
  }
  return 0;
};

const isEmpty = (value?: string | Array<any>) => {
  if (Array.isArray(value)) {
    return value.length === 0;
  }
  if (!value) return true;
  return value.trim().length === 0;
};

const languages = languageValues.modals.cadastroPauta;

const CadastroPautaModal = (props: ICadastroPautaModalProps) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [sent, setSent] = useState<boolean>(false);

  const [checked, setChecked] = useState<boolean>(false);
  const [edit, setEdit] = useState<boolean>(false);
  const [isGettingAgencias, gettingAgencias] = useState<boolean>(false);
  const [cancelConfirm, setCancelConfirm] = useState<boolean>(false);
  const [pautaRestrita, setPautaRestrita] = useState<boolean>(
    props.flgRestrita || false
  );
  const [pautaSecreta, setPautaSecreta] = useState<boolean>(
    props.flgSecreta || false
  );
  const [showAddCandidate, setShowAddCandidate] = useState<{
    show: boolean;
    id?: string;
  }>({ show: false });
  const [searchError, setSearchError] = useState<boolean>(false);

  const [optionEleicao, setOptionEleicao] = useState<string>();
  const [searchCandidate, setSearchCandidate] = useState<string>();
  const [searchMember, setSearchMember] = useState<string | undefined>();
  const [titulo, setTitulo] = useState<string>(props?.titulo || '');
  const [description, setDescription] = useState<string>(
    props?.descricao || ''
  );
  const [voteOption, setVoteOption] = useState<string>('');
  const [agencia, setAgencia] = useState<string>(props?.codigoAgencia || '');
  const [nucleo, setNucleo] = useState<string>(props?.numeroNucleo || '');

  const [listaAgencias, setListaAgencias] = useState<Agencia[]>([]);
  const [listaNucleos, setListaNucleos] = useState<Nucleo[]>([]);
  const [preAnexo, setPreAnexo] = useState<AnexoPautaType>();
  const [anexos, setAnexos] = useState<AnexoPautaType[]>([]);
  const [anexosLoading, setAnexosLoading] = useState(false);
  const [anexosDeletados, setAnexosDeletados] = useState<number[]>([]);
  const [listaTiposPauta, setListaTiposPauta] = useState<any>([]);
  const [currentTipoPauta, setCurrentTipoPauta] = useState<AssembleiaTipoPauta>(
    props?.tipoPauta || AssembleiaTipoPauta.Normal
  );

  const [addElectionCommision, setAddElectionCommision] =
    useState<boolean>(false);

  const abstentionText = 'Me Abstenho';

  const [validator, setValidator] = useState<CadastroPautaType>();

  const sortOptions = useCallback(
    (opA: IItensCadastrarPautaRequest, opB: IItensCadastrarPautaRequest) => {
      if (!opA.flgAbstencao && opB.flgAbstencao) return -1;
      if (opA.flgAbstencao && !opB.flgAbstencao) return 1;
      return 0;
    },
    []
  );

  const [candidate, setCandidate] = useState<any>(
    props?.itens
      ? props?.itens.length &&
        props?.itens.filter(
          (x: { descricao: string }) =>
            x.descricao.toLowerCase() === abstentionText.toLowerCase()
        )
        ? props.itens.sort(sortOptions)
        : [
            ...props.itens,
            {
              descricao: abstentionText,
              flgAbstencao: true,
            },
          ].sort(sortOptions)
      : [
          {
            descricao: abstentionText,
            flgAbstencao: true,
          },
        ]
  );

  const [singleVote, setSingleVote] = useState<IItensCadastrarPautaRequest[]>(
    props?.itens
      ? props?.itens.length &&
        props?.itens.filter(
          (x: { descricao: string }) =>
            x.descricao.toLowerCase() === abstentionText.toLowerCase()
        )
        ? props.itens.sort(sortOptions)
        : [
            ...props.itens,
            {
              descricao: abstentionText,
              flgAbstencao: true,
            },
          ].sort(sortOptions)
      : [
          {
            descricao: abstentionText,
            flgAbstencao: true,
          },
        ]
  );

  const [jobTitle, setJobTitle] = useState<any>([]);

  const [members, setMembers] = useState<MembersProps[]>([]);

  const [selectedMember, setSelectedMember] = useState<
    MembersProps | undefined
  >(undefined);
  const [selectedCandidate, setSelectedCandidate] = useState<any>();

  const [electionCommissions, setElectionCommissions] = useState<
    MembersProps[]
  >([]);

  const [candidateOptions, setCandidateOptions] = useState<OptionsProps[]>();

  const [electionCommissionsOptions, setElectionCommissionsOptions] =
    useState<any>();

  const [dropOpened, toggleDropOpened] = useDropOpened<number | undefined>(
    undefined
  );

  const [collapse, setCollapse] = useState<any>();

  const optionRef = useRef<any>([]);

  const cancelAnchor = useRef<HTMLElement>();
  const anexosEditados = useRef<number[]>([]);

  const { showToast } = useContext(LayoutContext);

  const candidateValidation = useMemo(() => {
    if (currentTipoPauta === 0 || currentTipoPauta === 2) {
      return singleVote!;
    } else {
      return candidate!;
    }
  }, [currentTipoPauta, candidate, singleVote]);

  useEffect(() => {
    setValidator(
      CadastroPautaValidator(
        titulo,
        agencia,
        nucleo,
        candidateValidation,
        electionCommissions,
        currentTipoPauta
      )
    );
  }, [
    titulo,
    agencia,
    nucleo,
    candidateValidation,
    electionCommissions,
    currentTipoPauta,
  ]);

  const handleDeleteAnexo = useCallback(
    (id: number | undefined, idTemporarioFront?: number) => {
      if (id) {
        if (anexosEditados.current.includes(id)) {
          anexosEditados.current = anexosEditados.current.filter(
            (a) => a !== id
          );
        }
        setAnexosDeletados(anexosDeletados.concat(id));
      } else if (idTemporarioFront) {
        setAnexos(
          anexos.filter((an) => an.idTemporarioFront !== idTemporarioFront)
        );
      }
    },
    [anexos, anexosDeletados]
  );

  const isEdit = useMemo(() => props?.idPauta !== undefined, [props]);

  const toClose = useCallback(
    (event?: MouseEvent<HTMLButtonElement>): void => {
      if (
        event &&
        (anexos.filter((anexo) => !anexo.oidAnexoPauta).length ||
          anexosDeletados.length ||
          anexosEditados.current.length)
      ) {
        cancelAnchor.current = event.target as HTMLElement;
        setCancelConfirm(!cancelConfirm);
      } else if (
        props &&
        props.modalKey &&
        typeof props?.onClose === 'function'
      ) {
        props?.onClose(props?.modalKey);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [anexos, anexosDeletados.length, props]
  );

  const carregarAnexos = useCallback(async () => {
    if (!props?.idPauta) return [];
    setAnexosLoading(true);
    try {
      if (props.registering) {
        const reqRegister = await getAttachmentRegister(
          props.idEvento,
          props.idPauta
        );
        setAnexos(reqRegister.data);
      } else {
        const req = await getAnexosPauta(props.idEvento, props.idPauta);
        setAnexos(req.data);
      }
    } catch (err) {
      showToast({
        pauseOnFocusLoss: true,
        theme: ToastTypes.Error,
        showStatusBar: true,
        timeout: 4000,
        label: languageValues.toasts.error.loadingAnexos,
      });
      toClose();
    } finally {
      setAnexosLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.idEvento, props.idPauta, showToast, toClose]);

  const handleCurrentTipoPautaChange = (tipo: number) => {
    setCurrentTipoPauta(tipo);
    if (tipo === 0) {
      setAgencia('');
      setNucleo('');
    }
  };

  const handleAddNewOp = (option: string) => {
    setVoteOption('');
    return setSingleVote(
      (prevState: Array<{ descricao: string; flgAbstencao: boolean }>) =>
        [
          ...prevState,
          {
            descricao: option,
            flgAbstencao: false,
          },
        ].sort(sortOptions)
    );
  };

  const isButtonAddDisabled = useMemo(() => isEmpty(voteOption), [voteOption]);

  const atualizarPautas = useCallback(() => {
    dispatch(
      assessorActionCarregarPautas(props!.idEvento, 0, ErrorHandler, () =>
        toClose()
      )
    );
  }, [dispatch, props, toClose]);

  const addOrUpdateNewOption = (id?: string) => {
    return setCandidate((prevState: any) => {
      if (id) {
        return [
          ...prevState.filter((x: { id: string }) => x.id !== id),
          {
            id: id,
            descricao: !optionEleicao
              ? candidate
                  .filter((x: { id: string }) => x.id === id)
                  .map((x: any) => x.descricao)
                  .toString()
              : optionEleicao.toString(),
            flgAbstencao: false,
            representantes: jobTitle.map(
              (e: {
                name: string;
                idAssociado: number;
                roleName: JobTitleTypes;
              }) => {
                return {
                  idAssociado: e.idAssociado,
                  roleName: e.roleName,
                  name: e.name,
                };
              }
            ),
          },
        ]

          .sort((a: { id: any }, b: { id: any }) =>
            a!.id!?.localeCompare(b!?.id!)
          )
          .sort(sortOptions);
      } else {
        return [
          ...prevState,
          {
            id: getUniqueKey(),
            descricao: optionEleicao,
            flgAbstencao: false,
            representantes: jobTitle.map(
              (e: {
                name: string;
                idAssociado: number;
                roleName: JobTitleTypes;
              }) => {
                return {
                  idAssociado: e.idAssociado,
                  roleName: e.roleName,
                  name: e.name,
                };
              }
            ),
          },
        ].sort(sortOptions);
      }
    });
  };

  const addElectionCommissions = (e: Array<MembersProps>) => {
    return setElectionCommissions((prevState: Array<MembersProps>) => [
      ...prevState,
      ...e,
    ]);
  };

  const addMembers = (e?: any) => {
    return setMembers((prevState: any) => [...prevState, e]);
  };

  const updateOrAddNewJobTitle = (e?: any) => {
    return setJobTitle((prevState: any) => {
      if (e.roleName === JobTitleTypes.Presidente) {
        return [
          ...prevState.filter(
            (item: { roleName: JobTitleTypes }) => item.roleName !== e.roleName
          ),
          { ...e },
        ];
      } else {
        return [...prevState, { ...e }];
      }
    });
  };

  const updateSelectedCandidate = (e?: any) => {
    return setSelectedCandidate((prevState: any) => {
      return { ...prevState, roleName: e };
    });
  };

  const getCandidate = async () => {
    const { data }: any = await api.searchMember({
      cooperative: props.cooperativa!,
      text: searchCandidate!,
    });

    if (data.length) {
      setSearchError(false);
      setCandidateOptions(
        data?.map((e: { name: string; id: number }) => {
          return {
            label: e.name,
            value: e.id,
          };
        })
      );
    } else {
      setSearchError(true);
    }
  };

  const idsToBlock = useCallback(() => {
    return electionCommissions.map((x: any) => x.value);
  }, [electionCommissions]);

  const getElectionCommissions = async () => {
    if (!searchMember) return;
    const { data }: any = await api.searchElectionCommissions({
      cooperative: props.cooperativa!,
      idsBlocked: idsToBlock(),
      text: searchMember,
    });

    if (data.length) {
      setSearchError(false);
      setElectionCommissionsOptions(
        data?.map((e: { name: string; id: number }) => {
          return {
            label: e.name,
            value: e.id,
          };
        })
      );
    } else {
      setSearchError(true);
    }
  };

  const updateCandidateOptions = useCallback(
    (e: any) => {
      setCandidateOptions(e.map((e: any) => e));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchCandidate]
  );

  const updateElectionCommissionsOptions = useCallback(
    (e: any) => {
      setElectionCommissionsOptions(e.map((e: any) => e));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchMember]
  );

  const jobTitles = (e: JobTitleTypes) => {
    switch (e) {
      case JobTitleTypes.Presidente:
        return 'Presidente';
      case JobTitleTypes.VicePresidente:
        return 'Vice Presidente';
      case JobTitleTypes.ConselheiroEfetivo:
        return 'Conselheiro Efetivo';
      case JobTitleTypes.ConselheiroSuplente:
        return 'Conselheiro Suplente';
    }
  };

  const optionType = (e: any) => {
    switch (e) {
      case 'Padrão':
        return 'Padrão';
      case 'Eleição':
        return 'Conselho';
      case 'Coordenador':
        return 'Coordenador';
    }
  };

  useEffect(() => {
    if (isEdit || checked || edit) {
      carregarAnexos();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [edit]);

  useEffect(() => {
    const getTiposPauta = async () => {
      const { fail, data }: any = await api.configs(props.idEvento);
      if (fail) {
        ErrorHandler(fail);
      }

      if (data) {
        setListaTiposPauta(data.agendaTypes);
        setElectionCommissions(
          data.electionCommissions.map((x: { name: string; id: number }) => {
            return {
              label: x.name,
              value: x.id,
            };
          })
        );
      }
    };

    getTiposPauta();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [edit]);

  useEffect(() => {
    if (currentTipoPauta === 2 && !listaAgencias.length) {
      const getAgencias = async () => {
        if (!props?.idEvento) return;
        gettingAgencias(true);
        const { fail, data } = !props.registering
          ? await api.listarAgencias(props.idEvento)
          : await api.getEventBranches(props.idEvento);

        if (fail) {
          ErrorHandler(fail);
        }
        if (data) {
          setListaAgencias(data);
        }
        gettingAgencias(false);
      };
      currentTipoPauta > AssembleiaTipoPauta.Normal && getAgencias();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props, currentTipoPauta, edit]);

  useEffect(() => {
    if (currentTipoPauta === 2) {
      const getNucleos = () => {
        const currentAgencia = listaAgencias.find(
          (entry: Agencia) => entry.agencia === agencia
        );
        const currentNucleos = currentAgencia?.nucleos;
        if (currentNucleos) {
          setListaNucleos(currentNucleos);
        }
      };
      !isEmpty(agencia) && getNucleos();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [agencia, listaAgencias, edit, agencia, nucleo]);

  useEffect(() => {
    if (currentTipoPauta !== 1 && !isEdit) {
      setOptionEleicao(undefined);
      setSearchCandidate(undefined);
      setSearchMember(undefined);
      setElectionCommissionsOptions(undefined);
      setSelectedCandidate(undefined);
      setSelectedMember(undefined);
      setSearchError(false);
      setCandidateOptions([]);
      setCandidate([
        {
          descricao: abstentionText,
          flgAbstencao: true,
        },
      ]);
      setMembers([]);
      setJobTitle([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTipoPauta]);

  useEffect(() => {
    if (currentTipoPauta === 1 && !isEdit) {
      setVoteOption('');
      setSingleVote([
        {
          descricao: abstentionText,
          flgAbstencao: true,
        },
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTipoPauta]);

  useEffect(() => {
    setSent(false);
  }, [currentTipoPauta]);

  useEffect(() => {
    if (!agencia) {
      setNucleo('');
    }
  }, [agencia]);

  const [optionId, setOptionId] = useState<string>('');
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [loaderButton, setLoaderButton] = useState<boolean>(false);

  const [editAnexo, setEditAnexo] = useState<boolean>(false);

  const [defaultStaves, setDefaultStaves] = useState<any>([]);
  const [loadingDefault, setLoadingDefault] = useState<boolean>(false);

  return (
    <Fragment>
      <Modal
        preventEscExit={props?.preventEscExit || false}
        preventMaskExit={props?.preventMaskExit || false}
        modalKey={props?.modalKey}
        mobileOn={props?.mobileOn}
        title={isEdit ? `${languages.editTitle}` : `${languages.registerTitle}`}
        className={rootClassName}
        onClose={props.onClose}
        compenseColPaddingContent
        size={ModalSizes.Large}
        footer={
          defaultStaves.length
            ? [
                {
                  theme: ButtonThemes.Secondary,
                  leftIcon: <CircleTimes />,
                  children: `Voltar`,
                  'aria-label': `Voltar`,
                  onClick: () => {
                    setDefaultStaves([]);
                  },
                },
              ]
            : !editAnexo
            ? showAddCandidate.show || addElectionCommision
              ? [
                  {
                    theme: ButtonThemes.Secondary,
                    leftIcon: <CircleTimes />,
                    children: `${languages.buttons.cancel}`,
                    'aria-label': `${languages.buttons.cancel}`,
                    onClick: () => {
                      if (addElectionCommision) {
                        setAddElectionCommision(false);
                        setSearchMember(undefined);
                        setMembers([]);
                        setOptionEleicao('');
                      } else {
                        setSearchCandidate(undefined);
                        setShowAddCandidate({ show: false });
                        setJobTitle([]);
                        setOptionEleicao('');
                      }
                    },
                    disabled: false,
                  },
                  {
                    theme: ButtonThemes.Primary,
                    leftIcon: <CheckCircleIcon />,
                    children: `${languages.buttons.save}`,
                    'aria-label': `${languages.buttons.save}`,
                    onClick: () => {
                      if (addElectionCommision) {
                        setAddElectionCommision(false);
                        addElectionCommissions(members);
                        setMembers([]);
                      } else {
                        addOrUpdateNewOption(optionId);
                        setShowAddCandidate({ show: false });
                        setOptionId('');
                        setOptionEleicao('');
                        setJobTitle([]);
                      }
                    },
                    disabled:
                      optionId && optionEleicao
                        ? false
                        : addElectionCommision
                        ? !members.length
                        : !jobTitle.length,
                  },
                ]
              : [
                  {
                    theme: ButtonThemes.Secondary,
                    leftIcon: <CircleTimes />,
                    children: `${languages.buttons.cancel}`,
                    'aria-label': `${languages.buttons.cancel}`,
                    onClick: toClose,
                    disabled: false,
                  },
                  {
                    theme: ButtonThemes.Primary,
                    leftIcon: <CheckCircleIcon />,
                    children:
                      isEdit && props?.liberadaPresencial && !edit
                        ? languages.buttons.edit
                        : props?.idPauta
                        ? languages.buttons.save
                        : languages.buttons.registerPauta,
                    'aria-label':
                      isEdit && props?.liberadaPresencial && !edit
                        ? languages.buttons.edit
                        : props?.idPauta
                        ? languages.buttons.save
                        : languages.buttons.registerPauta,
                    onClick:
                      isEdit && props?.liberadaPresencial && !edit
                        ? () => setEdit(true)
                        : () => {
                            return new Promise<any>(
                              (
                                resolve: (evt?: any) => void,
                                reject: () => void
                              ) => {
                                if (!props?.idEvento) return;
                                if (!sent) setSent(true);
                                if (validator && !validator.allIsValid())
                                  return;
                                setLoaderButton(true);
                                let idPauta = props.idPauta || undefined;

                                const pautaRequest: ICadastrarPautaRequest = {
                                  descricao: description,
                                  idEvento: props?.idEvento,
                                  itens:
                                    currentTipoPauta !== 1
                                      ? singleVote
                                      : candidate?.map((x: any) => {
                                          if (isEdit) {
                                            if (x.representantes?.length) {
                                              return {
                                                descricao: x.descricao,
                                                flgAbstencao: x.flgAbstencao,
                                                representantes:
                                                  x.representantes?.length &&
                                                  x.representantes?.map(
                                                    (x: {
                                                      idAssociado: number;
                                                      roleName: JobTitleTypes;
                                                    }) => {
                                                      return {
                                                        associateId:
                                                          x.idAssociado,
                                                        roleName: x.roleName,
                                                      };
                                                    }
                                                  ),
                                              };
                                            } else {
                                              return {
                                                descricao: x.descricao,
                                                flgAbstencao: x.flgAbstencao,
                                              };
                                            }
                                          } else {
                                            if (x.representantes) {
                                              return {
                                                descricao: x.descricao,
                                                flgAbstencao: x.flgAbstencao,
                                                representantes:
                                                  x.representantes?.map(
                                                    (x: {
                                                      idAssociado: number;
                                                      roleName: JobTitleTypes;
                                                    }) => {
                                                      return {
                                                        associateId:
                                                          x.idAssociado,
                                                        roleName: x.roleName,
                                                      };
                                                    }
                                                  ),
                                              };
                                            } else {
                                              return {
                                                descricao: x.descricao,
                                                flgAbstencao: x.flgAbstencao,
                                              };
                                            }
                                          }
                                        }),
                                  titulo,
                                  idPauta: isEdit ? props?.idPauta! : undefined,
                                  tipoPauta: currentTipoPauta,
                                  codigoAgencia: agencia,
                                  numeroNucleo: nucleo,
                                  flgRestrita: pautaRestrita,
                                  flgSecreta: pautaSecreta,
                                  flgCienteEdicao: checked,
                                  membrosCommisao:
                                    currentTipoPauta !== 1
                                      ? undefined
                                      : electionCommissions.map(
                                          (member: any) => member.value
                                        ),
                                };

                                const request = {
                                  eventId: props?.idEvento,
                                  agenda: {
                                    id: props.idPauta,
                                    agendaType: currentTipoPauta,
                                    title: titulo,
                                    description: description,
                                    branch: agencia,
                                    nucleus: nucleo,
                                    flagRestrict: pautaRestrita,
                                    flagSecret: pautaSecreta,
                                    items:
                                      currentTipoPauta !== 1
                                        ? singleVote.map((x: any) => {
                                            return {
                                              description: x.descricao,
                                              flagAbstention: x.flgAbstencao,
                                            };
                                          })
                                        : candidate?.map((x: any) => {
                                            if (isEdit) {
                                              if (x.representantes?.length) {
                                                return {
                                                  description: x.descricao,
                                                  flagAbstention:
                                                    x.flgAbstencao,
                                                  representatives:
                                                    x.representantes?.length &&
                                                    x.representantes?.map(
                                                      (x: {
                                                        idAssociado: number;
                                                        roleName: JobTitleTypes;
                                                      }) => {
                                                        return {
                                                          associateId:
                                                            x.idAssociado,
                                                          roleName: x.roleName,
                                                        };
                                                      }
                                                    ),
                                                };
                                              } else {
                                                return {
                                                  description: x.descricao,
                                                  flagAbstention:
                                                    x.flgAbstencao,
                                                };
                                              }
                                            } else {
                                              if (x.representantes) {
                                                return {
                                                  description: x.descricao,
                                                  flagAbstention:
                                                    x.flgAbstencao,
                                                  representatives:
                                                    x.representantes?.map(
                                                      (x: {
                                                        idAssociado: number;
                                                        roleName: JobTitleTypes;
                                                      }) => {
                                                        return {
                                                          associateId:
                                                            x.idAssociado,
                                                          roleName: x.roleName,
                                                        };
                                                      }
                                                    ),
                                                };
                                              } else {
                                                return {
                                                  description: x.descricao,
                                                  flagAbstention:
                                                    x.flgAbstencao,
                                                };
                                              }
                                            }
                                          }),
                                    electionCommissions:
                                      currentTipoPauta !== 1
                                        ? undefined
                                        : electionCommissions.map(
                                            (member: any) => member.value
                                          ),
                                    hasAttachments: anexos.length
                                      ? true
                                      : false,
                                    hasAnexos: anexos.length ? true : false,
                                  },
                                };

                                if (props.registering) {
                                  dispatch(
                                    assembleiasAssessorCadastrarPauta(
                                      request as any,
                                      true,
                                      async (req: any) => {
                                        showToast({
                                          pauseOnFocusLoss: true,
                                          theme: ToastTypes.Success,
                                          showStatusBar: true,
                                          timeout: 4000,
                                          label: isEdit
                                            ? languages.toast.succesEditPauta
                                            : languages.toast
                                                .successRegisterPauta,
                                        });
                                        idPauta = req.data.idPauta;
                                        const novosAnexos = anexos.filter(
                                          (a) => !a.oidAnexoPauta
                                        );

                                        if (idPauta) {
                                          await Promise.all([
                                            ...novosAnexos.map((a) => {
                                              return postAnexoPautaRegister(
                                                props.idEvento,
                                                idPauta!,
                                                a
                                              );
                                            }),
                                            ...anexosEditados.current.map(
                                              (ed) => {
                                                const a = anexos.find(
                                                  (an) =>
                                                    an.oidAnexoPauta === ed
                                                );
                                                if (a) {
                                                  return putAnexoPautaRegister(
                                                    props.idEvento,
                                                    idPauta!,
                                                    a
                                                  );
                                                }
                                                return Promise.resolve();
                                              }
                                            ),
                                            ...anexosDeletados.map((del) => {
                                              return deleteAnexoPautaRegister(
                                                props.idEvento,
                                                idPauta!,
                                                del
                                              );
                                            }),
                                          ]).finally(() => {
                                            props.onSend(request);
                                          });
                                        }
                                        resolve();
                                      },
                                      (error) => {
                                        showToast({
                                          pauseOnFocusLoss: true,
                                          theme: ToastTypes.Error,
                                          showStatusBar: true,
                                          timeout: 4000,
                                          label:
                                            languageValues.toasts.error.keyErrors(
                                              (error as AxiosError<any>)
                                                .response?.data.message,
                                              isEdit
                                                ? languages.toast.errorEditPauta
                                                : languages.toast
                                                    .errorRegisterPauta
                                            ),
                                        });
                                      },
                                      () => {
                                        props.onSend(request);
                                        toClose();
                                      }
                                    )
                                  );
                                } else {
                                  dispatch(
                                    assembleiasAssessorCadastrarPauta(
                                      pautaRequest as any,
                                      false,
                                      async (req) => {
                                        showToast({
                                          pauseOnFocusLoss: true,
                                          theme: ToastTypes.Success,
                                          showStatusBar: true,
                                          timeout: 4000,
                                          label: isEdit
                                            ? languages.toast.succesEditPauta
                                            : languages.toast
                                                .successRegisterPauta,
                                        });
                                        idPauta = req.data.idPauta;
                                        const novosAnexos = anexos.filter(
                                          (a) => !a.oidAnexoPauta
                                        );
                                        if (idPauta) {
                                          await Promise.all([
                                            ...novosAnexos.map((a) => {
                                              return postAnexoPauta(
                                                props.idEvento,
                                                idPauta!,
                                                a
                                              );
                                            }),
                                            ...anexosEditados.current.map(
                                              (ed) => {
                                                const a = anexos.find(
                                                  (an) =>
                                                    an.oidAnexoPauta === ed
                                                );
                                                if (a) {
                                                  return putAnexoPauta(
                                                    props.idEvento,
                                                    idPauta!,
                                                    a
                                                  );
                                                }
                                                return Promise.resolve();
                                              }
                                            ),
                                            ...anexosDeletados.map((del) => {
                                              return deleteAnexoPauta(
                                                props.idEvento,
                                                idPauta!,
                                                del
                                              );
                                            }),
                                          ]);
                                        }
                                        resolve();
                                      },
                                      (error: any) => {
                                        showToast({
                                          pauseOnFocusLoss: true,
                                          theme: ToastTypes.Error,
                                          showStatusBar: true,
                                          timeout: 4000,
                                          label:
                                            languageValues.toasts.error.keyErrors(
                                              (error as AxiosError<any>)
                                                .response?.data.message,
                                              isEdit
                                                ? languages.toast.errorEditPauta
                                                : languages.toast
                                                    .errorRegisterPauta
                                            ),
                                        });
                                        reject();
                                      },
                                      () => atualizarPautas()
                                    )
                                  );
                                }
                              }
                            );
                          },
                    disabled:
                      isEdit && props?.liberadaPresencial && !edit
                        ? !checked
                        : loaderButton ||
                          (sent && !!validator && !validator.allIsValid()),
                    loading: sent && loaderButton,
                  },
                ]
            : undefined
        }
      >
        <Row>
          {isEdit && props?.liberadaPresencial && !edit ? (
            <Fragment>
              <Col>
                <p>{languages.pautaAlreadyReleased}</p>
              </Col>
              <Col>
                <ControlLabel
                  labelPosition={ControlLabelPosition.Right}
                  control={
                    <Checkbox
                      theme={CheckboxThemes.Primary}
                      value={checked}
                      onChange={() => setChecked((event) => !event)}
                    />
                  }
                  label={languages.checkbox.proceedWithEditing}
                />
              </Col>
            </Fragment>
          ) : (
            <Fragment>
              <Collapse
                opened={
                  !Boolean(defaultStaves && defaultStaves.length) &&
                  !showAddCandidate.show &&
                  !addElectionCommision
                }
                animateOpacity
              >
                <Col noPaddingTop style={{ marginBottom: '12px' }}>
                  <Button
                    w100
                    onClick={() => {
                      if (!defaultStaves.length) {
                        setLoadingDefault(true);
                        loadDefaultStaves()
                          .then((data) => {
                            return setDefaultStaves(
                              data.data.map((x: any) => {
                                return {
                                  id: getUniqueKey(),
                                  ...x,
                                };
                              })
                            );
                          })
                          .finally(() => {
                            setLoadingDefault(false);
                          });
                      } else {
                        setDefaultStaves([]);
                      }
                    }}
                    style={{ height: '50px' }}
                    disabled={loadingDefault}
                    loading={loadingDefault}
                  >
                    Selecionar Pautas Pré-Definidas
                  </Button>
                </Col>
              </Collapse>
              <Collapse
                opened={Boolean(defaultStaves && defaultStaves.length)}
                animateOpacity
              >
                <Col>
                  <Select
                    data-testid={'select-default-staves'}
                    label={'Pauta Pré-Definida'}
                    options={getOptionsFromParams(
                      defaultStaves,
                      'id',
                      'titulo'
                    )}
                    onChange={(evt: string) => {
                      const filter = defaultStaves.filter(
                        (stave: { id: string }) => stave.id === evt
                      )[0];
                      setTitulo(filter.titulo);
                      handleCurrentTipoPautaChange(filter.tipoPauta);
                      setPautaRestrita(filter.flgRestrita);

                      if (filter.tipoPauta !== 1) {
                        setSingleVote(filter.itens);
                      } else {
                        setCandidate(
                          filter.itens.map(
                            (item: {
                              descricao: string;
                              flgAbstencao: boolean;
                              id?: string;
                              representantes?: any[];
                            }) => ({
                              ...item,
                              ...(item.flgAbstencao
                                ? {}
                                : { id: getUniqueKey(), representantes: [] }),
                            })
                          )
                        );
                      }

                      setTimeout(() => {
                        setDefaultStaves([]);
                      }, 100);
                    }}
                    placeholder={'Selecione a pauta Pré-Definida'}
                    value={''}
                    loading={loadingDefault}
                  />
                </Col>
              </Collapse>
              <Collapse opened={Boolean(!defaultStaves.length)} animateOpacity>
                <Collapse
                  opened={!showAddCandidate.show && !addElectionCommision}
                  animateOpacity
                >
                  <Menu
                    open={cancelConfirm}
                    onClose={() => setCancelConfirm(false)}
                    anchorEl={cancelAnchor.current}
                  >
                    <MenuItem disabled>
                      {languages.cancelSure}
                      <br />
                      {languages.cancelSutitle}
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        toClose();
                        setCancelConfirm(false);
                      }}
                    >
                      Sim
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        setCancelConfirm(false);
                      }}
                    >
                      Não
                    </MenuItem>
                  </Menu>
                  <Row>
                    <Col>
                      <Select
                        data-testid={'select-type-pauta'}
                        label={languages.inputs.pautaTypeLabel}
                        options={listaTiposPauta!?.map(
                          (item: TipoPautaResponse) => {
                            return {
                              label: `${optionType(item.name)}`,
                              value: item.value,
                            };
                          }
                        )}
                        onChange={(evt: number) => {
                          handleCurrentTipoPautaChange(evt);
                          setShowAddCandidate({ show: false });
                        }}
                        placeholder={'Selecione o tipo de pauta'}
                        value={currentTipoPauta}
                        clearButton={false}
                        disabled={!listaTiposPauta.length || isEdit}
                        loading={!listaTiposPauta.length}
                      />
                    </Col>
                    <Col>
                      <Input
                        data-testid={'input-title-pauta'}
                        value={titulo}
                        onChange={(
                          event: React.ChangeEvent<{ value: string }>
                        ) => {
                          return setTitulo(event.target.value);
                        }}
                        label={languages.inputs.pautaTitleLabel}
                        placeholder={languages.inputs.pautaTitlePlaceholder}
                        maxLength={MAX_INPUT_TITLE_LENGHT}
                        disabled={!listaTiposPauta.length}
                        error={
                          sent && validator && validator?.titlePauta()?.error
                        }
                        helperText={
                          sent && validator
                            ? validator?.titlePauta()?.helperText
                            : ''
                        }
                      />
                    </Col>
                    <Col>
                      <InputArea
                        data-testid={'input-description-pauta'}
                        value={description}
                        onChange={(
                          event: React.ChangeEvent<{ value: string }>
                        ) => {
                          return setDescription(event.target.value);
                        }}
                        label={languages.inputs.pautaDescriptionLabel}
                        placeholder={
                          languages.inputs.pautaDescriptionPlaceholder
                        }
                        maxLength={500}
                        disabled={!listaTiposPauta.length}
                        counter
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col gap={24}>
                      <ControlLabel
                        control={
                          <Checkbox
                            onChange={() =>
                              setPautaRestrita((evt: boolean) => !evt)
                            }
                            value={pautaRestrita}
                            disabled={!listaTiposPauta.length}
                          />
                        }
                        label={languages.checkbox.restrictPauta}
                      />

                      <ControlLabel
                        control={
                          <Checkbox
                            onChange={() =>
                              setPautaSecreta((evt: boolean) => !evt)
                            }
                            value={pautaSecreta}
                            disabled={!listaTiposPauta.length}
                          />
                        }
                        label={languages.checkbox.secretPauta}
                      />
                    </Col>
                  </Row>
                  <Row style={{ marginTop: 16 }}>
                    <Collapse opened={currentTipoPauta === 2} animateOpacity>
                      <Col>
                        <Select
                          data-testid={'select-agency'}
                          label={languages.inputs.pautaAgencyLabel}
                          placeholder={languages.inputs.pautaAgencyPlaceholder}
                          options={listaAgencias
                            .map((item: Agencia) => {
                              return {
                                label: item.agencia,
                                value: item.agencia,
                              };
                            })
                            .sort((agnA, agnB) => {
                              return agnA.value < agnB.value ? -1 : 1;
                            })}
                          onChange={(evt: string) => {
                            setAgencia(evt);
                            setNucleo('');
                          }}
                          value={agencia}
                          disabled={!listaAgencias?.length}
                          loading={isGettingAgencias}
                          error={
                            sent && validator && validator?.agency()?.error
                          }
                          helperText={
                            sent && validator
                              ? validator?.agency()?.helperText
                              : ''
                          }
                        />
                      </Col>
                      <Col>
                        <Select
                          data-testid={'select-nucleou'}
                          label={languages.inputs.pautaNucleousLabel}
                          placeholder={
                            languages.inputs.pautaNucleousPlaceholder
                          }
                          options={listaNucleos
                            .map((item: Nucleo) => {
                              return { label: item.nucleo, value: item.nucleo };
                            })
                            .sort((nucA, nucB) => {
                              return nucA.value < nucB.value ? -1 : 1;
                            })}
                          onChange={(evt: string) => setNucleo(evt)}
                          value={nucleo}
                          disabled={!listaAgencias?.length || !agencia}
                          loading={isGettingAgencias}
                          error={
                            sent && validator && validator?.nucleou()?.error
                          }
                          helperText={
                            sent && validator
                              ? validator?.nucleou()?.helperText
                              : ''
                          }
                        />
                      </Col>
                    </Collapse>
                  </Row>
                  <Collapse opened={currentTipoPauta !== 1} animateOpacity>
                    <Row>
                      <Col cols={[8, 8, 8, 8, 8]}>
                        <Input
                          data-testid={'input-single-option-vote'}
                          value={voteOption}
                          onChange={(e: React.ChangeEvent<{ value: string }>) =>
                            setVoteOption(e.target.value)
                          }
                          label={languages.inputs.pautaOptionLabel}
                          placeholder={languages.inputs.pautaOptionPlaceholder}
                          maxLength={100}
                          disabled={!listaTiposPauta.length}
                          error={
                            sent &&
                            validator &&
                            validator?.candidateOptions()?.error
                          }
                          helperText={
                            sent && validator
                              ? validator?.candidateOptions()?.helperText
                              : ''
                          }
                        />
                      </Col>
                      <Col
                        cols={[4, 4, 4, 4, 4]}
                        className={classes.buttonAdicionar}
                        end
                      >
                        <Button
                          data-testid={'button-add-option'}
                          theme={ButtonThemes.Primary}
                          onClick={() => handleAddNewOp(voteOption)}
                          disabled={isButtonAddDisabled}
                          leftIcon={<AddCircleIcon />}
                        >
                          {languages.buttons.addOption}
                        </Button>
                      </Col>
                    </Row>
                  </Collapse>
                  <Collapse opened={currentTipoPauta === 1} animateOpacity>
                    <Row className={`${rootClassName}-add-options`}>
                      <Col cols={[8, 8, 8, 8, 8]}>
                        <Input
                          data-testid={'input-candidate-option-vote'}
                          value={optionEleicao}
                          onChange={(e: React.ChangeEvent<{ value: string }>) =>
                            setOptionEleicao(e.target.value)
                          }
                          label={languages.voteOption}
                          placeholder={languages.inputs.pautaOptionPlaceholder}
                          maxLength={100}
                          error={
                            currentTipoPauta === 1 &&
                            sent &&
                            validator &&
                            validator?.candidateOptions()?.error
                          }
                          helperText={
                            currentTipoPauta === 1 && sent && validator
                              ? validator?.candidateOptions()?.helperText
                              : ''
                          }
                        />
                      </Col>
                      <Col cols={[4, 4, 4, 4, 4]} end>
                        <Button
                          data-testid={'button-add-candidate'}
                          theme={ButtonThemes.Primary}
                          leftIcon={<AddIcon />}
                          onClick={() => {
                            setJobTitle([]);
                            addOrUpdateNewOption();
                            setOptionEleicao('');
                          }}
                          disabled={
                            !optionEleicao ||
                            (jobTitle.length && !optionEleicao)
                          }
                        >
                          {languages.buttons.addCandidates}
                        </Button>
                      </Col>
                      <Col>
                        <p>{languages.voteOption}</p>
                      </Col>
                      <Col
                        className={`${rootClassName}-votes-eleicao-container`}
                      >
                        {candidate!?.map(
                          (
                            option: IItensCadastrarPautaRequest,
                            index: number
                          ) => {
                            return (
                              <div
                                ref={(ref) => (optionRef.current[index] = ref)}
                                key={index}
                                className={`${rootClassName}-options candidate`}
                                onClick={(event) => {
                                  event?.stopPropagation();
                                  if (Boolean(option.representantes?.length)) {
                                    setCollapse((prev: any) =>
                                      prev === option.id ? false : option.id
                                    );
                                  }
                                }}
                              >
                                <div
                                  className={`${rootClassName}-options-container`}
                                >
                                  <div className={`${rootClassName}-label`}>
                                    <span className={'nunito'}>
                                      {option.descricao}
                                    </span>
                                  </div>

                                  {!option.flgAbstencao ? (
                                    <div
                                      className={`${rootClassName}-actions`}
                                      onClick={(event) =>
                                        event?.stopPropagation()
                                      }
                                    >
                                      <DropdownMenu
                                        opened={
                                          String(dropOpened) === String(index)
                                        }
                                        setOpened={(val) =>
                                          toggleDropOpened(index, val)
                                        }
                                        closeOnOutClick
                                        content={
                                          <div
                                            style={{
                                              display: 'flex',
                                              flexDirection: 'column',
                                            }}
                                          >
                                            <DropdownItem
                                              label={
                                                option.representantes!?.length
                                                  ? 'Editar opção'
                                                  : 'Cadastrar candidatos'
                                              }
                                              onClick={() => {
                                                setOptionId(option?.id!);
                                                if (
                                                  option.representantes!?.length
                                                ) {
                                                  setOptionEleicao(
                                                    candidate
                                                      .filter(
                                                        (x: { id: string }) =>
                                                          x.id === option.id
                                                      )
                                                      .map(
                                                        (x: any) => x.descricao
                                                      )
                                                  );
                                                  setJobTitle(
                                                    option.representantes
                                                  );
                                                }
                                                setShowAddCandidate({
                                                  show: true,
                                                  id: option.representantes!
                                                    ?.length
                                                    ? option.id
                                                    : undefined,
                                                });
                                                toggleDropOpened(index, false);
                                              }}
                                            />
                                            <DropdownItem
                                              label={'Remover opção'}
                                              onClick={() => {
                                                setTimeout(() => {
                                                  toggleDropOpened(
                                                    index,
                                                    dropOpened !== index
                                                  );
                                                  setCandidate(
                                                    candidate!?.filter(
                                                      (_: any, i: number) =>
                                                        index !== i
                                                    )
                                                  );
                                                }, 500);
                                                toggleDropOpened(index, false);
                                              }}
                                            />
                                          </div>
                                        }
                                      >
                                        <IconButton
                                          icon={<ThreeDots />}
                                          onClick={() => {
                                            toggleDropOpened(
                                              index,
                                              dropOpened !== index
                                            );
                                          }}
                                        />
                                      </DropdownMenu>
                                      {Boolean(
                                        option.representantes?.length
                                      ) ? (
                                        <IconButton
                                          tabIndex={-1}
                                          className={`${rootClassName}-arrow ${rootClassName}-arrow-${
                                            collapse === option.id
                                              ? 'up'
                                              : 'down'
                                          }`}
                                          onClick={() => {
                                            setCollapse((prev: any) =>
                                              prev === option.id
                                                ? false
                                                : option.id
                                            );
                                          }}
                                          icon={<ChevronArrowDownIcon />}
                                        />
                                      ) : undefined}
                                    </div>
                                  ) : undefined}
                                </div>
                                {option.id !== abstentionText ? (
                                  <Collapse
                                    opened={
                                      Boolean(option.representantes?.length) &&
                                      collapse === option.id
                                    }
                                    animateOpacity
                                  >
                                    <div
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '8px',
                                        marginTop: '10px',
                                      }}
                                    >
                                      {groupByKey(
                                        option.representantes!,
                                        'roleName'
                                      )!?.map((x) => {
                                        return (
                                          <Col
                                            key={index}
                                            className={`${rootClassName}-options`}
                                          >
                                            <div
                                              className={`${rootClassName}-label`}
                                            >
                                              <span className={'office'}>
                                                {jobTitles(x.roleName!)}
                                              </span>
                                              {x.data.map(
                                                (
                                                  items: {
                                                    name: string;
                                                    idAssociado: number;
                                                  },
                                                  index: number
                                                ) => (
                                                  <div
                                                    key={index}
                                                    className={`${rootClassName}-name-actions`}
                                                  >
                                                    <span className={'nunito'}>
                                                      {items.name}
                                                    </span>
                                                  </div>
                                                )
                                              )}
                                            </div>
                                          </Col>
                                        );
                                      })}
                                    </div>
                                  </Collapse>
                                ) : undefined}
                              </div>
                            );
                          }
                        )}
                      </Col>
                      <Row
                        className={clsx([
                          `${rootClassName}-election-commissions`,
                          currentTipoPauta === 1 &&
                          sent &&
                          validator &&
                          validator?.electionCommissionOptions()?.error
                            ? 'error'
                            : '',
                        ])}
                      >
                        <Col>
                          <p>{languages.addElectionCommissions}</p>
                          <span>
                            {validator?.electionCommissionOptions()?.helperText}
                          </span>
                        </Col>
                        <Col>
                          <Button
                            data-testid={'button-add-election-commissions'}
                            leftIcon={<AddCircleIcon />}
                            onClick={() => {
                              setAddElectionCommision(true);
                            }}
                          >
                            {languages.buttons.addElectionCommissions}
                          </Button>
                        </Col>
                        <Col
                          className={`${rootClassName}-votes-eleicao-container`}
                        >
                          {electionCommissions?.map(
                            (option: any, index: number) => {
                              return (
                                <div
                                  key={index}
                                  className={`${rootClassName}-options`}
                                >
                                  <div className={`${rootClassName}-label`}>
                                    <span className={'nunito'}>
                                      {option.label}
                                    </span>
                                  </div>
                                  <div className={`${rootClassName}-actions`}>
                                    <IconButton
                                      onClick={() => {
                                        setElectionCommissions(
                                          electionCommissions.filter(
                                            (_, i: number) => index !== i
                                          )
                                        );
                                      }}
                                      icon={<TrashIcon />}
                                    />
                                  </div>
                                </div>
                              );
                            }
                          )}
                        </Col>
                      </Row>
                    </Row>
                  </Collapse>
                  <Collapse
                    opened={
                      !!Boolean(singleVote.length) &&
                      currentTipoPauta !== 1 &&
                      Boolean(listaTiposPauta.length)
                    }
                    animateOpacity
                  >
                    <Col>
                      <p>{languages.voteOption}</p>
                    </Col>
                    {singleVote?.map(
                      (it: IItensCadastrarPautaRequest, index: number) => {
                        return (
                          <Col
                            className={`${rootClassName}-votes-eleicao-container`}
                            key={index}
                          >
                            <div className={`${rootClassName}-options`}>
                              <div className={`${rootClassName}-label`}>
                                <span className={'nunito'}>{it.descricao}</span>
                              </div>
                              {!it.flgAbstencao ? (
                                <div className={`${rootClassName}-actions`}>
                                  <IconButton
                                    onClick={() => {
                                      setSingleVote(
                                        singleVote.filter(
                                          (_, i: number) => index !== i
                                        )
                                      );
                                    }}
                                    icon={<TrashIcon />}
                                  />
                                </div>
                              ) : undefined}
                            </div>
                          </Col>
                        );
                      }
                    )}
                  </Collapse>
                  <Collapse
                    opened={Boolean(listaTiposPauta.length)}
                    animateOpacity
                  >
                    <Row>
                      <Col>
                        <p>{languages.addAttachments}</p>
                      </Col>
                      <Col gap={16} className={classes.actions}>
                        <ButtonFileUpload
                          allowedFileTypes={[
                            FileTypes.PDF,
                            FileTypes.JPG,
                            FileTypes.JPEG,
                            FileTypes.PNG,
                          ]}
                          leftIcon={<FilePlusIcon />}
                          label={languages.buttons.addDocuments}
                          theme={ButtonThemes.Secondary}
                          onTypeNotAllowed={() => {
                            showToast({
                              pauseOnFocusLoss: true,
                              theme: ToastTypes.Error,
                              showStatusBar: true,
                              timeout: 4000,
                              label: languageValues.toasts.error.typeNotAllowed,
                            });
                          }}
                          onChange={(e: File | File[]) => {
                            if ((e as File).size > 35000000) {
                              showToast({
                                pauseOnFocusLoss: true,
                                theme: ToastTypes.Error,
                                showStatusBar: true,
                                timeout: 4000,
                                label: languageValues.toasts.error.uploadSize,
                              });
                            } else {
                              setPreAnexo({
                                tipoAnexo: AnexoEnum.DOCUMENTO,
                                descricao: '',
                                flgDisponivelAssociado: true,
                                file: e as File,
                              });
                            }
                          }}
                        />
                        <Button
                          data-testid={'button-add-video'}
                          leftIcon={<PlayIcon />}
                          onClick={() => {
                            setPreAnexo({
                              tipoAnexo: AnexoEnum.VIDEO,
                              descricao: '',
                              url: '',
                              flgDisponivelAssociado: true,
                            });
                          }}
                        >
                          {languages.buttons.addVideo}
                        </Button>
                      </Col>
                    </Row>
                    <Row style={{ marginBottom: preAnexo ? '16px' : 0 }}>
                      <Col>
                        <PreAnexoPautaItem
                          anexo={preAnexo}
                          onCancel={() => {
                            setPreAnexo(undefined);
                          }}
                          onAdd={(newAnexo) => {
                            setAnexos(anexos.concat(newAnexo));
                            setPreAnexo(undefined);
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      {anexosLoading && (
                        <Col centralized>
                          <ThreeDotsLoader size={2} />
                        </Col>
                      )}
                    </Row>
                    <Row className={classes.itensAnexoPautaRow}>
                      {!anexos.length
                        ? undefined
                        : anexos.sort(sortAnexos).map((anexo, i) => {
                            return !anexo.oidAnexoPauta ||
                              !anexosDeletados.includes(anexo.oidAnexoPauta) ? (
                              <Col>
                                <AnexoPautaItem
                                  idEvento={props?.idEvento!}
                                  idPauta={props?.idPauta!}
                                  key={anexo.oidAnexoPauta ?? getUniqueKey()}
                                  anexo={anexo}
                                  register={props.registering}
                                  onRemove={(id) =>
                                    handleDeleteAnexo(
                                      id,
                                      anexo.idTemporarioFront
                                    )
                                  }
                                  isEditing={(e) => {
                                    setEditAnexo(e);
                                  }}
                                  onEdit={(anexo) => {
                                    if (
                                      anexo.oidAnexoPauta &&
                                      !anexosEditados.current.includes(
                                        anexo.oidAnexoPauta
                                      )
                                    ) {
                                      anexosEditados.current.push(
                                        anexo.oidAnexoPauta
                                      );
                                    }
                                    setAnexos(
                                      anexos.map((a, index) => {
                                        if (
                                          (a.oidAnexoPauta &&
                                            a.oidAnexoPauta ===
                                              anexo.oidAnexoPauta) ||
                                          index === i
                                        ) {
                                          return anexo;
                                        }
                                        return a;
                                      })
                                    );
                                  }}
                                />
                              </Col>
                            ) : undefined;
                          })}
                    </Row>
                  </Collapse>
                </Collapse>
                <Collapse opened={showAddCandidate.show} animateOpacity>
                  <Row>
                    {optionId && optionEleicao ? (
                      <Col>
                        <Input
                          data-testid={'input-name-option-vote'}
                          value={optionEleicao}
                          onChange={(e: React.ChangeEvent<{ value: string }>) =>
                            setOptionEleicao(e.target.value)
                          }
                          label={languages.voteOption}
                          placeholder={languages.inputs.pautaOptionPlaceholder}
                          maxLength={100}
                        />
                      </Col>
                    ) : undefined}
                    <Col>
                      <Search
                        label={languages.inputs.searchNameOrCPFLabel}
                        placeholder={
                          languages.inputs.searchNameOrCPFPlaceholder
                        }
                        value={searchCandidate!}
                        onChange={(e: string) => {
                          if (searchError) {
                            setSearchError(false);
                          }
                          setSearchCandidate(e.toUpperCase());
                        }}
                        onSelect={(record: { value: number; label: string }) =>
                          setSelectedCandidate({
                            idAssociado: record?.value,
                            name: record?.label,
                          })
                        }
                        data={candidateOptions}
                        loadData={() => {
                          return new Promise(
                            (resolve: (_?: any) => void, reject) => {
                              getCandidate()
                                .then((e) => {
                                  updateCandidateOptions(e);
                                  resolve();
                                })
                                .catch(() => reject());
                            }
                          );
                        }}
                        clearButton
                        error={searchError}
                        helperText={
                          searchError ? 'Associado não encontrado' : undefined
                        }
                      />
                    </Col>
                    <Col>
                      <Select
                        data-testid={'select-job-title'}
                        label={languages.inputs.jobTitleLabel}
                        placeholder={languages.inputs.jobTitlePlaceholder}
                        options={[
                          {
                            label: 'Presidente',
                            value: JobTitleTypes.Presidente,
                          },
                          {
                            label: 'Vice Presidente',
                            value: JobTitleTypes.VicePresidente,
                          },
                          {
                            label: 'Conselheiro Efetivo',
                            value: JobTitleTypes.ConselheiroEfetivo,
                          },
                          {
                            label: 'Conselheiro Suplente',
                            value: JobTitleTypes.ConselheiroSuplente,
                          },
                        ]}
                        onChange={(evt: number) => updateSelectedCandidate(evt)}
                        value={selectedCandidate?.roleName}
                        disabled={!selectedCandidate}
                      />
                    </Col>
                    <Col>
                      <Button
                        data-testid={'button-add-candidates'}
                        theme={ButtonThemes.Primary}
                        leftIcon={<AddCircleIcon />}
                        onClick={() => {
                          updateOrAddNewJobTitle(selectedCandidate);
                          setCandidateOptions([]);
                          setSelectedCandidate(undefined);
                          setSearchCandidate(undefined);
                        }}
                        disabled={
                          (!selectedCandidate?.id &&
                            !selectedCandidate?.roleName) ||
                          searchError
                        }
                      >
                        {languages.buttons.add}
                      </Button>
                    </Col>
                    <Collapse opened={Boolean(jobTitle.length)} animateOpacity>
                      <Col
                        className={`${rootClassName}-votes-eleicao-container`}
                      >
                        {groupByKey(jobTitle!, 'roleName')?.map(
                          (option, index: number) => {
                            return (
                              <Col
                                key={index}
                                className={`${rootClassName}-options`}
                              >
                                <div className={`${rootClassName}-label`}>
                                  <span className={'office'}>
                                    {jobTitles(option.roleName!)}
                                  </span>
                                  {option.data.map(
                                    (items: {
                                      name: string;
                                      idAssociado: number;
                                    }) => (
                                      <div
                                        className={`${rootClassName}-name-actions`}
                                      >
                                        <span className={'nunito'}>
                                          {items.name}
                                        </span>
                                        <div
                                          className={`${rootClassName}-actions`}
                                        >
                                          <IconButton
                                            onClick={() => {
                                              setJobTitle(
                                                jobTitle.filter(
                                                  (it: {
                                                    idAssociado: number;
                                                  }) =>
                                                    items.idAssociado !==
                                                    it.idAssociado
                                                )
                                              );
                                            }}
                                            icon={<TrashIcon />}
                                          />
                                        </div>
                                      </div>
                                    )
                                  )}
                                </div>
                              </Col>
                            );
                          }
                        )}
                      </Col>
                    </Collapse>
                  </Row>
                </Collapse>
                <Collapse opened={addElectionCommision} animateOpacity>
                  <Row>
                    <Col cols={[6, 6, 6, 6, 6]}>
                      <div className={`${rootClassName}-member-title`}>
                        <strong className={'nunito'}>
                          {languages.members}
                        </strong>
                        <p className={'nunito'}>{languages.moreMembers}</p>
                      </div>
                    </Col>
                    <Col cols={[6, 6, 6, 6, 6]} end>
                      <Button
                        data-testid={'button-add-new'}
                        theme={ButtonThemes.Secondary}
                        leftIcon={<AddCircleIcon />}
                        onClick={() => {
                          addMembers(selectedMember);
                          setSelectedMember(undefined);
                          setSearchMember('');
                        }}
                        disabled={!selectedMember || searchError}
                      >
                        {languages.buttons.addNew}
                      </Button>
                    </Col>
                    <Col>
                      <Search
                        label={languages.inputs.searchMemberLabel}
                        placeholder={languages.inputs.searchMemberPlaceholder}
                        value={searchMember!}
                        onChange={(e: string) => {
                          if (searchError) {
                            setSearchError(false);
                          }
                          setSearchMember(e.toUpperCase());
                        }}
                        onSelect={(record: any) => setSelectedMember(record!)}
                        data={electionCommissionsOptions}
                        loadData={() => {
                          return new Promise(
                            (resolve: (_?: any) => void, reject) => {
                              getElectionCommissions()
                                .then((e) => {
                                  updateElectionCommissionsOptions(e);
                                  resolve();
                                })
                                .catch(() => reject());
                            }
                          );
                        }}
                        clearButton
                        error={searchError}
                        helperText={
                          searchError ? 'Associado não encontrado' : undefined
                        }
                      />
                    </Col>
                    <Collapse opened={Boolean(members.length)} animateOpacity>
                      <Col
                        className={`${rootClassName}-votes-eleicao-container`}
                      >
                        {members?.map((option: any, index: number) => {
                          return (
                            <Col
                              key={index}
                              className={`${rootClassName}-options`}
                            >
                              <div className={`${rootClassName}-label`}>
                                <span className={'nunito'}>{option.label}</span>
                              </div>
                              <div className={`${rootClassName}-actions`}>
                                <IconButton
                                  onClick={() => {
                                    setMembers(
                                      members.filter(
                                        (_: any, i: number) => index !== i
                                      )
                                    );
                                  }}
                                  icon={<TrashIcon />}
                                />
                              </div>
                            </Col>
                          );
                        })}
                      </Col>
                    </Collapse>
                  </Row>
                </Collapse>
              </Collapse>
            </Fragment>
          )}
        </Row>
      </Modal>
    </Fragment>
  );
};

export default CadastroPautaModal;
